import React, { useState } from 'react'
import { toast } from 'react-toastify'
import UpdateCollectionStatusService from '../../Services/Mutations/UpdateCollectionStatusService'
import { ToastStyle } from '../Data/MovieStaticData'

export default function SearchandStatus(props) {
  const {
    searchText,
    SearchText,
    searchButton,
    selectStatus,
    status,
    Cleartext,
    checkedArray,
    setLoadSpinner,
    setCheckedArray,
    listMovieCollections,
    setlistMovieCollections,
    BulkActionPermission,
  } = props
  const [Actions, setActions] = useState('')
  const selectActions = e => {
    setActions(e.target.value)
  }

  const ApplyBulk = () => {
    setLoadSpinner(true)
    const listMovieCollectionsTemp = [...listMovieCollections]

    // let listMovieCollectionsTempeory = []
    checkedArray.map(async item => {
      const response = await UpdateCollectionStatusService({
        movieCollectionID: item.movieCollectionID,
        status: Actions,
      })
      if (response.statusCode === 'M022') {
        toast.success(response.statusMessage, ToastStyle)
      }
    })
    const remainingElements =
      listMovieCollectionsTemp &&
      listMovieCollectionsTemp.filter(elem => !checkedArray.find(element => elem.SK === element.SK))
    setlistMovieCollections(remainingElements)
    setLoadSpinner(false)
    setCheckedArray([])
  }

  return (
    <>
      <div style={{ display: 'flex', gap: '10px' }}>
        <input
          className='rounded w-50'
          value={searchText}
          onChange={event => SearchText(event.target.value)}
          disabled={status === 'draft'}
        />
        <button
          type='button'
          className='btn btn-primary'
          onClick={() => searchButton()}
          disabled={searchText === ''}
        >
          Search
        </button>
        <button type='button' className='btn btn-primary' onClick={() => Cleartext()}>
          clear
        </button>
      </div>
      <div style={{ width: '40%' }}>
        <label>Status:</label>
        <select
          className='form-select'
          aria-label='Default select example'
          onChange={e => selectStatus(e)}
          disabled={searchText !== ''}
        >
          <option selected={status === 'published'} value='published'>
            published
          </option>

          <option selected={status === 'draft'} value='draft'>
            Draft
          </option>
        </select>
      </div>
      {BulkActionPermission && checkedArray && checkedArray.length >= 1 && (
        <div style={{ display: 'flex', gap: '10px' }}>
          <div style={{ width: '40%' }}>
            <label>Bulk Actions:</label>
            <select
              className='form-select'
              aria-label='Default select example'
              onChange={e => selectActions(e)}
              disabled={searchText !== ''}
            >
              <option selected={Actions === ''} value='' disabled></option>
              {status === 'draft' && (
                <option selected={Actions === 'published'} value='published'>
                  approve
                </option>
              )}

              <option selected={Actions === 'deleted'} value='deleted'>
                Delete
              </option>
            </select>
          </div>
          <div style={{ position: 'relative', top: '30px' }}>
            <button
              className='btn btn-primary'
              type='button'
              disabled={!Actions}
              onClick={() => ApplyBulk()}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </>
  )
}
